import React from "react";
import Navbar from "./global-components/navbar-v3";
// import Navbar from "./global-components/navbar";
import Banner from "./section-components/banner-v3";
// import Banner from "./section-components/banner-v2";
import SearchForm from "./section-components/search-form";
import Features from "./section-components/features-v1";
// import ProductSlider from "./section-components/product-slider-v3";
import ProductSlider from "./section-components/product-slider-v2";
import Neighbour from "./section-components/neighbour";
import FeaturedItem from "./section-components/featured-item-v1";
// ProductsSection
import SolarBatteryProducts from "./section-components/solar-battery-products";
import SolarInverterProducts from "./section-components/solar-inverter-products";
import EBikeBatteryProducts from "./section-components/e-bike-battery-products";
import Video from "./section-components/video-v1";
import Testimonial from "./section-components/testimonial-v3";
import Sponsor from "./section-components/sponsor-v1";
import Cateogory from "./section-components/category-v2";

import BlogSlider from "./blog-components/blog-slider-v1";
import CallToActionV1 from "./section-components/call-to-action-v1";
import Footer from "./global-components/footer";

const Home_V3 = () => {
  return (
    <div>
      <Navbar />

      {/* Hero Section */}
      <Banner />

      {/* <SearchForm /> */}
      {/* <Features customClass="ltn__feature-area section-bg-1--- pt-115 pb-90 mb-120---" /> */}

      {/* Products Carousel Section */}
      {/* <SolarBatteryProducts /> */}
      <SolarInverterProducts />
      <EBikeBatteryProducts />

      {/* Our Focus Area Section */}
      <ProductSlider />

      {/* Power Wall Usability Facts */}
      {/* <Neighbour /> */}

      {/* <Video /> */}
      {/* <Testimonial /> */}
      {/* <Sponsor /> */}

      {/* Key Features */}
      {/* <Cateogory /> */}

      {/* Latest News Section */}
      <BlogSlider sectionClass="pt-120" />

      {/* <CallToActionV1 /> */}
      <Footer />
    </div>
  );
};

export default Home_V3;
